import React, { MouseEvent, PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { ModalBody, ModalCenteredContainer, ModalContainer, Overlay } from 'Common/components/styled/CommonModal';
import BlueSpinner from 'Common/components/BlueSpinner';
import { FontFamily } from 'Common/constants/theme';

const Modal = ({ onClickOutside, maxWidth, saving, children, className }: PropsWithChildren<{
  onClickOutside?: () => void;
  saving?: boolean;
  maxWidth?: string;
  className?: string;
}>) => {

  const onOutsideClick = () => {
    if (onClickOutside !== undefined) {
      onClickOutside();
    }
  };

  const onModalClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  return <Overlay onMouseDown={onOutsideClick}>
    <ModalContainer onMouseDown={onModalClick} $maxWidth={maxWidth} className={className}>
      {
        saving ? <ModalCenteredContainer><BlueSpinner/></ModalCenteredContainer> : null
      }
      <ModalBody>
        {children}
      </ModalBody>
    </ModalContainer>
  </Overlay>;
};

export const MetalModal = styled(Modal)`
  border-radius: 48px;
  background: linear-gradient(106deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0) 100%), #282831;
  box-shadow:
    2px 2px 2px 0 rgba(255, 255, 255, 0.2) inset,
    -2px -1px 1px 0 rgba(0, 0, 0, 0.3) inset,
    0 4px 16px 0 rgba(0, 0, 0, 0.25),
    0 4px 48px 0 rgba(0, 0, 0, 0.3);

  color: #fff;
  width: 100%;
  box-sizing: border-box;
  font-feature-settings:
    'liga' off,
    'clig' off;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

const Button = styled.button`
  flex: 1;
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  position: relative;

  border-radius: 28px;
  border: 0.75px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;

  color: #fff;
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;

  font-family: ${FontFamily};
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.43px;

  &:hover {
    opacity: 0.8;
  }
`;

export const SecondaryButton = styled(Button)`
  background: rgba(255, 255, 255, 0.1);
`;

export const PrimaryButton = styled(Button)`
  background: #ff7c00;
`;

export default Modal;
